<section class="login-wrapper">
  <div class="container-fluid login-shell p-0">
    <div class="row g-0 h-100">
      <div class="col-lg-6 d-none d-lg-block">
        <aside class="login-visual" aria-label="GarageDigital para tu taller">
          <img
            src="../../assets/images/login-hero-ai.png"
            alt="Vehículo en un taller moderno"
            class="login-visual__image"
          />
          <div class="login-visual__overlay"></div>

          <div class="login-visual__content">
            <span class="login-visual__eyebrow">
              <i class="bi bi-stars" aria-hidden="true"></i>
              Tu taller, mejor conectado
            </span>
            <h2 gdClarityUnmask>
              Todo el control de tu negocio en un solo lugar.
            </h2>
            <p>
              Gestioná clientes, trabajos y operaciones con una experiencia
              simple, rápida y diseñada para talleres que avanzan.
            </p>

            <div class="login-visual__features" aria-label="Beneficios">
              <span><i class="bi bi-check-circle-fill"></i> Simple</span>
              <span><i class="bi bi-check-circle-fill"></i> Seguro</span>
              <span
                ><i class="bi bi-check-circle-fill"></i> Siempre online</span
              >
            </div>
          </div>
        </aside>
      </div>

      <div class="col-12 col-lg-6 d-flex align-items-center">
        <div class="login-panel w-100">
          <header class="brand">
            <img
              src="../../assets/images/GD_Logotipo_UI.png"
              alt="GarageDigital"
              class="brand__logo"
            />
          </header>

          <div class="login-panel__heading">
            <span class="login-panel__kicker d-lg-none"
              >Bienvenido de nuevo</span
            >
            <h1 gdClarityUnmask>Ingresá a tu cuenta</h1>
            <p>Usá tus datos para continuar a tu espacio de trabajo.</p>
          </div>

          <form [formGroup]="loginForm" (ngSubmit)="logIn()" novalidate>
            <div class="form-field mb-4">
              <label class="form-label" for="email">Correo electrónico</label>
              <div class="input-wrap">
                <i
                  class="bi bi-envelope input-wrap__icon"
                  aria-hidden="true"
                ></i>
                <input
                  id="email"
                  type="email"
                  [formControl]="emailControl"
                  class="form-control form-control-lg"
                  placeholder="nombre@correo.com"
                  autocomplete="email"
                  [attr.aria-invalid]="
                    emailControl.invalid && emailControl.touched
                  "
                  [attr.aria-describedby]="
                    emailControl.invalid && emailControl.touched
                      ? 'email-errors'
                      : null
                  "
                  [ngClass]="{
                    'is-invalid': emailControl.invalid && emailControl.touched,
                  }"
                />
              </div>
              <div
                id="email-errors"
                class="invalid-feedback d-block"
                *ngIf="emailControl.invalid && emailControl.touched"
              >
                <div *ngFor="let error of emailControl.errors | keyvalue">
                  {{ error | controlErrorMessage }}
                </div>
              </div>
            </div>

            <div class="form-field">
              <label class="form-label" for="password">Contraseña</label>
              <div class="input-wrap">
                <i class="bi bi-lock input-wrap__icon" aria-hidden="true"></i>
                <input
                  id="password"
                  [type]="inputType"
                  [formControl]="passwordControl"
                  class="form-control form-control-lg"
                  placeholder="Ingresá tu contraseña"
                  autocomplete="current-password"
                  [attr.aria-invalid]="
                    passwordControl.invalid && passwordControl.touched
                  "
                  [attr.aria-describedby]="
                    passwordControl.invalid && passwordControl.touched
                      ? 'password-errors'
                      : null
                  "
                  [ngClass]="{
                    'is-invalid':
                      passwordControl.invalid && passwordControl.touched,
                  }"
                />
              </div>
              <div
                id="password-errors"
                class="invalid-feedback d-block"
                *ngIf="passwordControl.invalid && passwordControl.touched"
              >
                <div *ngFor="let error of passwordControl.errors | keyvalue">
                  {{ error | controlErrorMessage }}
                </div>
              </div>
            </div>

            <div class="login-options d-flex align-items-center">
              <mat-checkbox
                [checked]="showPassword"
                (change)="toggleShowPassword()"
              >
                Mostrar contraseña
              </mat-checkbox>
              <a routerLink="/forgot-password" class="ms-auto"
                >Olvidé mi contraseña</a
              >
            </div>

            <gd-button
              [isLoading]="isLoading"
              [disabled]="isLoading"
              buttonType="submit"
              classes="w-100 login-submit"
              iconName="arrow_forward"
              [label]="isLoading ? 'Iniciando sesión...' : 'Ingresar'"
            ></gd-button>

            <ng-container *ngIf="isGoogleAuthEnabled">
              <div class="login-divider d-flex align-items-center">
                <span></span>
                <small>o continuá con</small>
                <span></span>
              </div>

              <button
                type="button"
                class="btn google-button w-100"
                [disabled]="isLoading"
                (click)="continueWithGoogle()"
              >
                <gd-inline-spinner *ngIf="isLoading" size="sm" tone="current" />
                <i
                  *ngIf="!isLoading"
                  class="bi bi-google"
                  aria-hidden="true"
                ></i>
                Continuar con Google
              </button>
            </ng-container>

            <p class="register-link text-center mb-0">
              ¿Todavía no tenés una cuenta?
              <a routerLink="/register">Creá una ahora</a>
            </p>
          </form>

          <p class="login-panel__footer text-center mb-0">
            <i class="bi bi-shield-check" aria-hidden="true"></i>
            Acceso seguro a GarageDigital
          </p>
        </div>
      </div>
    </div>
  </div>
</section>
